import { render, staticRenderFns } from "./Negative.vue?vue&type=template&id=1f9dc8b5&scoped=true&"
import script from "./Negative.vue?vue&type=script&lang=js&"
export * from "./Negative.vue?vue&type=script&lang=js&"
import style0 from "./Negative.vue?vue&type=style&index=0&id=1f9dc8b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9dc8b5",
  null
  
)

export default component.exports